import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { NAVIGATION_LINKS_DATA } from '../../constants';
import useUserDetails from '../hooks/useUserDetails';
import useErrorModal from '../hooks/useErrorModal';
import CustomButton from '../reusable/CustomButton';
import { markSjwPhotoUploadComplete } from '../../services/sjwPhotoUploadService';

type Props = { schoolId: string };

const SjwPhotoUploadCompleteButton = ({ schoolId }: Props) => {
  const navigate = useNavigate();
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();
  const { handleOpen: handleOpenErrorModal } = useErrorModal();
  const [isMarkingComplete, setIsMarkingComplete] = useState(false);

  const handleMarkComplete = async () => {
    if (!userDetails || !schoolId) return;
    setIsMarkingComplete(true);
    try {
      await markSjwPhotoUploadComplete(userDetails.eoaId, userDetails.access_token, schoolId);
      navigate(NAVIGATION_LINKS_DATA.SJW_PHOTO_UPLOAD.path);
    } catch (error) {
      handleOpenErrorModal('Could not mark photo upload as complete.', error as AxiosError);
    } finally {
      setIsMarkingComplete(false);
    }
  };

  return (
    <CustomButton
      variant="primary"
      size="medium"
      buttonText="Photo upload complete"
      buttonAction={handleMarkComplete}
      loading={isMarkingComplete}
    />
  );
};

export default SjwPhotoUploadCompleteButton;
